import { OmitType, PartialType } from '../../../utils';
import { CreateSettlementDto } from './create-settlement.dto';
export class UpdateSettlementDto extends PartialType(OmitType(CreateSettlementDto, ['vendorId', 'payments'])) {
}
